import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { CatalogForm } from '../../../components/CatalogForm/CatalogForm';
import { Validators } from '../../../components/CatalogForm/validators';
import { TransportistaRutaService } from '../../../services/TransportistaRutaService';

const TransportistaRutaForm = () => {
  const routeParams = useParams() || {};
  const id = routeParams.id || null;

  // Options states
  const [transportistasOptions, setTransportistasOptions] = useState([]);
  const [circuitosOptions, setCircuitosOptions] = useState([]);

  // Load form select options
  useEffect(() => {
    let isMounted = true;
    const fetchOptions = async () => {
      const data = await TransportistaRutaService.obtenerOpcionesForm();
      if (isMounted && data) {
        if (data.transportistas && Array.isArray(data.transportistas)) {
          setTransportistasOptions(
            data.transportistas.map((t) => ({
              value: t.id,
              label: t.transportista_nombre || t.transportista || String(t.id),
            }))
          );
        }
        if (data.circuitos && Array.isArray(data.circuitos)) {
          setCircuitosOptions(
            data.circuitos.map((c) => ({
              value: c.id,
              label: c.circuito || String(c.id),
            }))
          );
        }
      }
    };
    fetchOptions();
    return () => {
      isMounted = false;
    };
  }, []);

  // Pre-load data in edit mode
  const loadData = useCallback(async (recordId) => {
    return await TransportistaRutaService.obtenerPorId(recordId);
  }, []);

  // Submit handler
  const handleSubmit = useCallback(async (values) => {
    const payload = {
      ...values,
      id: id,
    };
    return await TransportistaRutaService.guardar(payload);
  }, [id]);

  // Form field configurations
  const fields = useMemo(() => [
    {
      name: 'id_transportista',
      label: 'Transportista',
      type: 'select',
      col: 4,
      required: true,
      options: transportistasOptions,
      validators: [Validators.required('El transportista es obligatorio')],
    },
    {
      name: 'id_circuito',
      label: 'Circuito',
      type: 'select',
      col: 4,
      required: true,
      options: circuitosOptions,
      validators: [Validators.required('El circuito es obligatorio')],
    },
    {
      name: 'costo',
      label: 'Costo',
      type: 'number',
      col: 4,
      required: true,
      placeholder: '0.00',
      validators: [
        Validators.required('El costo es obligatorio'),
        Validators.number('El costo debe ser un valor numérico'),
      ],
    },
  ], [transportistasOptions, circuitosOptions]);

  return (
    <CatalogForm
      title="Ruta Transportista"
      subtitle="Asignación de circuitos y tarifas de costo para transportistas"
      fields={fields}
      initialValues={{
        id_transportista: '',
        id_circuito: '',
        costo: '',
      }}
      id={id}
      loadData={loadData}
      onSubmit={handleSubmit}
      backUrl="/Catalogo/TransportistasRutas"
    />
  );
};

export default TransportistaRutaForm;
